import { EventHandlerBase, Primitive } from "pytha2";
import { AxisNetPrimitive } from "../primitive/AxisNetPrimitive";



/**
 * 删除轴网相关图元
 */
export class EventHandlerDeleteAxisNetRelate extends EventHandlerBase {

    run(data?: {}) {
        const params = this.node.graph.cache.inputObject['PARAMS'];
        const axisNetPrimitives: Primitive[] = params?.axisNetPrimitives || [];
        let axisNetPrimitiveUuids = axisNetPrimitives?.map(item => item.uuid) || [];

        // 先删除所有轴线图元
        const storage = this.getPythaStorage();
        let axisLineSegments = Object.keys(storage.primitiveStore.primitiveDict)?.map(key => {
            let entity = storage.primitiveStore.primitiveDict[key];
            // 属于需要变更的轴线段
            if (!!(entity as AxisNetPrimitive)?.axisNetUuid
                && axisNetPrimitiveUuids?.some(anu => anu === (entity as AxisNetPrimitive)?.axisNetUuid)
                && entity.type === 'AxisLineSegment') {
                return entity;
            }
            // 属于需要变更的轴网
            if (axisNetPrimitiveUuids?.some(anu => anu === entity.uuid)) {
                return entity;
            }
            return null;
        })?.filter(item => !!item) || [];
        axisLineSegments?.forEach(primitive => {
            primitive.needDelete = true;
        })

        return true;
    }
}